import React, { useState } from 'react';
import { useSelector, useDispatch } from 'react-redux';

import Input from '@material-ui/core/Input';
import FormControl from '@material-ui/core/FormControl';
import Tooltip from '@material-ui/core/Tooltip';
import IconButton from '@material-ui/core/IconButton';

import Skeleton from '@material-ui/lab/Skeleton';

import ViewColumnIcon from '@material-ui/icons/ViewWeekSharp';

import { SELECT_TABLE_COLUMNS } from '../SelectTable/constants';
import { DIMENSIONS } from '../../styles/constants';
import selectTableSlice from '../SelectTable/selectTableSlice';
import Select from '../Select';
import { buildSelectItems } from './utils';

import { makeStyles } from '@material-ui/core/styles';
import { useTranslation } from 'react-i18next';

const useStyles = makeStyles(theme => ({
	focusableButton: {
		'&:focus': {
			boxShadow: ''
		}
	}
}));

const OptionalColumnsSelect = () => {
	const { t } = useTranslation();
	const [optColSelectOpened, setOptColSelectOpened] = useState(false);
	const optionalColumns = useSelector(state => state.selectTable.optionalColumns);
	const selectedOptionalColumns = useSelector(state => state.selectTable.selectedOptionalColumns);
	const items = useSelector(state => state.designList.items);
	const progressActive = useSelector(state => state.tabbar.progressActive);
	const dispatch = useDispatch();

	const buttonId = 'openColSelectButton';
	const inputId = 'opt-columns-select';

	const dispatchAllColumns = (columns, newSelectedOptionalColumns) => {
		dispatch(
			selectTableSlice.actions.setAllColumns({
				columns,
				selectedOptionalColumns: newSelectedOptionalColumns
			})
		);
	};

	/* Event handlers */
	const handleOptColumns = event => {
		if (!selectedOptionalColumns.includes('all') && event.target.value.includes('all')) {
			dispatchAllColumns(
				SELECT_TABLE_COLUMNS.concat(optionalColumns.slice(1)),
				optionalColumns.map(oc => oc.key)
			);
		} else if (selectedOptionalColumns.includes('all') && !event.target.value.includes('all')) {
			dispatchAllColumns(SELECT_TABLE_COLUMNS, []);
		} else if (
			selectedOptionalColumns.includes('all') &&
			event.target.value.includes('all') &&
			event.target.value.length < optionalColumns.length
		) {
			dispatchAllColumns(
				SELECT_TABLE_COLUMNS.concat(
					optionalColumns.filter(optCol => event.target.value.filter(c => c !== 'all').includes(optCol.key))
				),
				event.target.value.filter(c => c !== 'all')
			);
		} else {
			dispatchAllColumns(
				SELECT_TABLE_COLUMNS.concat(optionalColumns.filter(optCol => event.target.value.includes(optCol.key))),
				event.target.value
			);
		}
	};

	const handleOptColumnSelectOpened = opened => {
		setOptColSelectOpened(opened);
	};

	const classes = useStyles();

	return progressActive ? (
		<Skeleton variant="circle" width={DIMENSIONS.SKELETON_BUTTON_HEIGHT} height={DIMENSIONS.SKELETON_BUTTON_HEIGHT} />
	) : (
		<FormControl>
			<Select
				button={
					<Tooltip title={t('components.optionalColumn')}>
						<IconButton
							id={buttonId}
							htmlFor={inputId}
							aria-label="Select optional columns"
							disabled={progressActive || items.length < 1}
							onClick={() => handleOptColumnSelectOpened(true)}
							className={classes.focusableButton}>
							<ViewColumnIcon />
						</IconButton>
					</Tooltip>
				}
				buttonId={buttonId}
				value={selectedOptionalColumns}
				items={buildSelectItems(optionalColumns)}
				multiple
				open={optColSelectOpened}
				onOpen={() => handleOptColumnSelectOpened(true)}
				onClose={() => handleOptColumnSelectOpened(false)}
				onChange={handleOptColumns}
				input={<Input id={inputId} />}
				renderValue={selected => selected.join(', ')}
			/>
		</FormControl>
	);
};

export default OptionalColumnsSelect;
